import { render, staticRenderFns } from "./myStudy.vue?vue&type=template&id=d3977dba&scoped=true"
import script from "./myStudy.vue?vue&type=script&lang=js"
export * from "./myStudy.vue?vue&type=script&lang=js"
import style0 from "./myStudy.vue?vue&type=style&index=0&id=d3977dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3977dba",
  null
  
)

export default component.exports